import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Pagination,Row,Col} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import {viewFlatFile} from '../../Utilities/WSUtil';
import {FILE_NAME,API_BASE_URL} from '../../resources/constant';

import {SubmitBtn,MidCifBtn} from '../../theme/MorsTheme';

import {ContentDiv, BodyHeaderDiv, BodyHeaderText} from '../../theme/MorsTheme';
import axios from 'axios';

const propTypes = {
    items: PropTypes.array.isRequired,
    onChangePage: PropTypes.func.isRequired,
    initialPage: PropTypes.number,
    pageSize: PropTypes.number
}

const defaultProps = {
    initialPage: 1,    
    pageSize: 20
}

class MerchFileList extends Component{            
    constructor(props){
        super(props);                  
        this.state = {
            url:API_BASE_URL+'cad/merchant/getMerchCreditNotice?',
            pager: {},
            pageOfItems: [],
            totalPage:''
        };  
        this.viewReport = this.viewReport.bind(this);
        this.onChangePage = this.onChangePage.bind(this);            
    }

    viewReport(merchantId){
        // alert(merchantId +" "+this.props.UploadDate);
        //this.props.getCreditReports(merchantId,this.props.UploadDate)
        axios(this.state.url + "merchId="+merchantId+"&upldDate="+this.props.UploadDate, {
            headers: {'Authorization': `Bearer ${localStorage.getItem('accessToken')}`},
            method: "GET",
            responseType: "blob"

        }).then(response => {                
          
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                //IE11 and the legacy version Edge support
                console.log("IE & Edge");
                let blob = new Blob([response.data], { type: "text/html" });
                window.navigator.msSaveOrOpenBlob(blob, "CN.pdf");
            } else {// other browsers
                console.log("response data = " + response.data);
                const file = new Blob([response.data], { type: "application/pdf" });
                console.log("file = " + file);    
                //Build a URL from the file
                const fileURL = URL.createObjectURL(file);
                console.log("fileURL = " + fileURL);
                //Open the URL on new Window
                const pdfWindow = window.open();
                pdfWindow.location.href = fileURL;
            }
            
         }).catch(error =>{ 
            //console.log("err: "+JSON.stringify(error))
            console.log(error);
            this.setState({
                fetchMessage: 'Sorry, there is/are no recorded transaction/s for the date you selected.'
            })                                     
        }) ;
    }

    goBack = e => {
        e.preventDefault();
        this.props.history.goBack();
    }
    onChangePage(pageOfItems){        
        this.setState({pageOfItems: pageOfItems});
    }

    componentWillMount(){        

        if(this.props.items && this.props.items.length){            
            this.setPage(this.props.initialPage);
        }
        
    }
    componentDidMount(){ 
        //alert("SingleId" + this.props.SingleId);
        //this.props.items.map((item, index) =>            
        //    this.props.SingleId === item.merchant?this.setState({totalPage: 1}):''
        //)
    }
    
    componentDidUpdate(prevProps, prevState){     
        if(this.props.items !== prevProps.items){         
            this.setPage(this.props.initialPage);
        }
    }
    setPage(page){
        var {items, pageSize} = this.props;
        var pager = this.state.pager;
        if(page<1 || page > pager.totalPages){
            return;
        }        
        pager = this.getPager(items.length, page, pageSize);
        var pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);
        this.setState({pager: pager});        
        this.onChangePage(pageOfItems); 
        
        var totalP= Math.ceil(this.props.items.length/pageSize)
        this.setState({totalPage: totalP});
    }

    getPager(totalItems, currentPage, pageSize){                               
        currentPage = currentPage || 1;
        pageSize = pageSize || 20;        
        var totalPages = Math.ceil(totalItems/pageSize);        
        var startPage, endPage;        
        if(totalPages <=10){
            startPage = 1;
            endPage = totalPages;
        }
        
        else{
            if(currentPage <=4){
                startPage = 1;
                endPage = 20;
            }else if(currentPage + 4 >= totalPages){
                startPage = totalPages - 4;
                endPage = totalPages;
            }else{
                startPage = currentPage - 20;
                endPage = currentPage + 4;                
            }
        }

        var startIndex = (currentPage - 1 ) * pageSize;
        var endIndex = Math.min(startIndex + pageSize -1, totalItems -1);
        var pages = [...Array((endPage +1) - startPage).keys()].map(i=> startPage +i);

        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages:pages
        };    
    }
                     
    render(){        
        var pager = this.state.pager;
        return(
            <div >                            
                <BodyHeaderDiv>
                    <BodyHeaderText>List of Reports</BodyHeaderText>
                </BodyHeaderDiv>
                <ContentDiv >
                    <div align="center">            
                    <Row as={Row} noGutters style={this.props.items.length !== 0 ? {display:'block'}: {display:'none'}}>    
                    <Row noGutters>
                            <Col md={20}>The following is/are the only Merchant ID/s that have reports:</Col>
                    </Row>
                        {//this.state.pageOfItems.map((item, index) =>
                            this.state.pageOfItems.sort((a,b) => a.merchant - b.merchant).map((item, index) =>
                            <Row key={index} style={{fontSize:'12px'}}>
                                <Col md={12}>                                
                                <Link onClick={() => this.viewReport(item.merchant)} to="#" >  {/* target="_blank">*/ }
                                <span style={{fontSize:'12px'}}>{item.merchant}</span></Link>
                                {/* <a  style={{color:'blue',fontSize:'12px',fontWeight:'bold'}} onClick={() => this.viewReport(item.merchant)} target="_blank">{item.merchant}</a> */}
                                {/* {   this.props.SingleId !== ''?
                                            (item.merchant === this.props.SingleId?<a  style={{color:'blue',fontSize:'12px',fontWeight:'bold'}} onClick={() => this.viewReport(item.merchant, item.uploadDate)}>{item.merchant}</a>:<span></span> )
                                            :<a  style={{color:'blue',fontSize:'12px',fontWeight:'bold'}} onClick={() => this.viewReport(item.merchant, item.uploadDate)}>{item.merchant}</a>
                                } */}
                                </Col>
                            </Row>
                            )}                                            
                    </Row>
                    </div>
                    <div align="center" style={this.props.items.length !== 0 ? {display:'block', marginTop: '20px'}: {display:'none'}}>                            
                        <Pagination style={{display: 'flex', justifyContent:'center'}}>
                            <Pagination.First onClick={() => this.setPage(1)} />                                                                        
                            <Pagination.Prev onClick={() => this.setPage(pager.currentPage - 1)}/>                                                                        
                            <Pagination.Next onClick={() => this.setPage(pager.currentPage + 1)}/>
                            <Pagination.Last onClick ={() => this.setPage(pager.totalPages)}/>                     
                        </Pagination>                                             
                        
                        <div align="center">
                            <span>Page {pager.currentPage}</span> / {" "}                            
                            <span>{this.state.totalPage}</span>
                        </div>  
                    </div>
                    
                                
                    <Row>
                        <Col>
                        <div style={this.props.items.length === 0 ? {display:'block'}: {display:'none'}}>
                            <span style={{color:'red'}}>Sorry, there is/are no recorded transaction/s for the date you selected.</span>                                                                                   
                        </div>
                        </Col>
                    </Row>
                    <Row style={{ marginTop:'20px'}}>
                        <Col>
                        <SubmitBtn style={{color:'#FFFFFF'}} onClick= {this.goBack}>Back</SubmitBtn>
                        </Col>

                    </Row>
                
            </ContentDiv>
        </div>                                  
    )
        
    }
    
}

MerchFileList.propTypes = propTypes;
MerchFileList.defaultProps = defaultProps;
export default MerchFileList;
